export default {
    methods: {
        surveyConfirmationDueClickHandler(practice) {
            this.$router.push({name: 'practice-survey-confirmation', params: {id: practice.organisationPtrId}})
        }
    }
}
